import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { SanitizedRichText } from "@/components/confluence/util/sanitized-rich-text";
import { Benefit, BenefitContainer } from "@/content/templates/template.types";

export const tabbedSectionStyle = {
    "marginBlockStart": 56,
    "marginInlineStart": "auto",
    "marginInlineEnd": "auto",

    "@media (max-width: 39.99rem)": {
        maxWidth: "100%"
    }
};

const stepContainerStyle = css({
    "display": "flex",
    "justifyContent": "space-between",
    "paddingBlockEnd": "3rem",
    "marginBlockEnd": "3rem",
    "borderBlockEnd": "2px solid #ebecf0",
    "gap": "2rem",

    "@media (max-width: 39.99rem)": {
        flexDirection: "column"
    },

    ":last-of-type": {
        borderBlockEnd: "none"
    }
});

export const tabbedSectionHeading = {
    "fontSize": "2.25rem",
    "lineHeight": "2.75rem",
    "fontWeight": 500,
    "letterSpacing": 0.3,
    "color": "#1d3059",
    "fontFamily": "var(--bxp-charlie-display-font-family)",
    "margin": 0,
    "marginBlockEnd": 40,

    "@media (max-width: 47.99rem)": {
        fontSize: "1.5rem",
        lineHeight: "1.75rem"
    }
};

const stepHeading = css({
    fontSize: "1.5rem",
    lineHeight: "2rem",
    fontWeight: 500,
    letterSpacing: 0.3,
    color: "#1d3059",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    margin: 0,

    [media.below.sm]: {
        fontSize: "1.25rem",
        lineHeight: "1.5rem"
    }
});

const stepContentWrapper = css({
    "display": "flex",
    "flexDirection": "column",
    "gap": "2rem",

    "@media (max-width: 39.99rem)": {
        gap: "1.5rem"
    }
});

const TemplateBenefitsStep = (templateBenefitDetail: Benefit) => {
    return (
        <div css={stepContainerStyle}>
            <div css={stepContentWrapper}>
                <h3 css={stepHeading}>{templateBenefitDetail.name}</h3>
                {templateBenefitDetail.shortDescription && (
                    <SanitizedRichText
                        innerHTML={templateBenefitDetail.shortDescription}
                    />
                )}
            </div>
        </div>
    );
};

export const TemplateBenefitsSection = ({
    templateBenefitContainer,
    benefitsTitle
}: BenefitContainer) => {
    return (
        <section css={css(tabbedSectionStyle)}>
            <h2 css={css(tabbedSectionHeading)}>{benefitsTitle}</h2>
            {templateBenefitContainer?.map(
                (benefitDetail: Benefit, index: number) => (
                    <TemplateBenefitsStep
                        key={`benefit-${index}`}
                        name={benefitDetail.name}
                        shortDescription={benefitDetail.shortDescription}
                    />
                )
            )}
        </section>
    );
};
